import { say } from "../localization/say.ts";

export function statusWord(status: string): string {
  if (status === "connected") return say("integrations.status.connected");
  if (status === "disconnected") return say("integrations.status.disconnected");
  return say("integrations.status.error");
}

export function scopeWord(scope: string): string {
  const said: Record<string, string> = {
    "calendar.read": say("integrations.scope.calendar.read"),
    "mail.read": say("integrations.scope.mail.read"),
    "mail.send": say("integrations.scope.mail.send"),
    "chat.read": say("integrations.scope.chat.read"),
    "chat.send": say("integrations.scope.chat.send"),
    "video.search": say("integrations.scope.video.search"),
    "video.read": say("integrations.scope.video.read"),
  };
  return said[scope] ?? scope;
}

export function providerName(provider: string): string {
  const said: Record<string, string> = {
    google: say("integrations.provider.google"),
    proton: say("integrations.provider.proton"),
    whatsapp: say("integrations.provider.whatsapp"),
    telegram: say("integrations.provider.telegram"),
    slack: say("integrations.provider.slack"),
    youtube: say("integrations.provider.youtube"),
  };
  return said[provider] ?? provider;
}
